import settings from "@settings";

export const divider = {
  height: ".5px",
  width: "100%",
  marginTop: settings.sizes.medium,
  marginBottom: settings.sizes.medium,
};
